import { PageContent } from "@/shared/widgets/layout/PageContent";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui/button";
import { PlusIcon } from "lucide-react";
import LearningList from "./LearningList";

const LearningsIndex = () => {
    const navigate = useNavigate();

    const createButton = (
        <Button onClick={() => navigate("/learning/new")}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Novo Conteúdo
        </Button>
    );

    return (
        <PageContent
            title="Conteúdos"
            items={[
                {
                    label: "Início",
                    href: "/",
                },
                {
                    label: "Conteúdos",
                    href: "/learning",
                },
            ]}
            actions={createButton}
        >
            <div className="rounded-lg overflow-hidden ">
                <LearningList />
            </div>
        </PageContent>
    );
};

export default LearningsIndex;